import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet } from 'react-native';
import { BodyText, theme, useResponsive } from '@sg/garnish';

export const OrderPlaybackTitle = () => {
  const { minWidth, currentHeight } = useResponsive();
  const withSmallerFont = minWidth.isSM && currentHeight.isSM;
  const fontSize: '16' | '18' = withSmallerFont ? '16' : '18';

  return (
    <BodyText style={styles.text} sizeMatch={[fontSize]}>
      <FormattedMessage {...messages.title} />
    </BodyText>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  title: {
    defaultMessage: 'Placing your order...',
    description: 'Bag | Order playback | Title',
  },
});

// ─── Styles ───────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  text: {
    color: theme.colors.KALE,
  },
});
